import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getAwards, deleteAwards } from '../../actions/awardActions'
import Table from 'react-bootstrap/Table';
import '../css/pages/Aboutus.css'

const AwardListing = ({ ...props }) => {

  useEffect(() => {
    props.getAwards()
  }, [])

  const handleChange = (id, index) => {
    props.deleteAwards(id, index)
  }

  return <>
    <section id="main" className="couponlisting clearfix" role="main">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-11 shadow-lg p-3 mb-5 bg-body rounded">
            <h3 className="text-dark main-title-border ">Award List </h3>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Award</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  props.list.map((eachAward, index) => {
                    return (
                      <tr>
                        <td>{index + 1}</td>
                        <td><img src={eachAward.source} style={{ height: '100px', width: '100px' }} /></td>
                        <td>{eachAward.type}</td>
                        <td><span onClick={() => handleChange(eachAward._id, index)}>Delete</span></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </section>
  </>
}

const mapStateToProps = (state) => ({
  list: state.awards.list
})

export default connect(mapStateToProps, { getAwards, deleteAwards })(AwardListing)